import { useMemo } from 'react';
import { useLocations } from '@/hooks/useLocations';

/**
 * Resolve a single `location_id` to its canonical iso_alpha2 + English name
 * using the cached locations list. Safe for use inside list cards because
 * `useLocations` fetches once and is shared across the tree.
 *
 * Per project memory: `location_id` is the SOURCE OF TRUTH for jurisdictional
 * data. Use this hook in card components to display location instead of
 * relying on the deprecated `users.country` legacy column.
 */
export function useLocationById(locationId: number | null | undefined) {
  const { locations, isLoading } = useLocations();

  return useMemo(() => {
    if (!locationId) return { isoAlpha2: null, name: null, isLoading };
    const match = locations.find((l) => l.location_id === locationId);
    return {
      isoAlpha2: match?.iso_alpha2 || null,
      name: match?.name || null,
      isLoading,
    };
  }, [locationId, locations, isLoading]);
}
